module.exports = __webpack_public_path__ + "img/Procurement1.c275620a.png";